import * as React from "react";
const SvgFiRrRadar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-radar_svg__a)">
      <path
        fill="#062147"
        d="M21.406 19.469C19.099 22.349 15.675 24 12.011 24a12.01 12.01 0 0 1-9.406-4.531c-3.467-4.327-3.467-10.611 0-14.938C6.61-.467 13.804-1.475 18.982 2.238a2.51 2.51 0 0 1 1.035 1.845 2.63 2.63 0 0 1-.763 2.077l-4.426 4.426a1 1 0 0 1-1.414 0 2 2 0 0 0-1.589-.578 2 2 0 0 0-1.479.863 2.03 2.03 0 0 0 0 2.258 1.99 1.99 0 0 0 1.479.863 1.99 1.99 0 0 0 1.589-.578.999.999 0 1 1 1.414 1.414 4 4 0 0 1-3.176 1.157 4.02 4.02 0 0 1-2.943-1.708c-.94-1.341-.94-3.214 0-4.555a4.02 4.02 0 0 1 2.943-1.708 4.04 4.04 0 0 1 2.379.539l1.445-1.445a6.01 6.01 0 0 0-7.523.461q.046.208.047.43a2 2 0 0 1-1.645 1.968 6.01 6.01 0 0 0 1.402 6.275 5.96 5.96 0 0 0 2.654 1.542A2 2 0 0 1 12 16.999c.648 0 1.223.308 1.588.785a5.96 5.96 0 0 0 2.655-1.542 5.95 5.95 0 0 0 1.693-5.124 1 1 0 1 1 1.978-.291 8.04 8.04 0 0 1-2.257 6.829 7.95 7.95 0 0 1-3.816 2.126 2 2 0 0 1-3.682 0 7.95 7.95 0 0 1-3.816-2.126c-2.258-2.258-2.881-5.541-1.87-8.366a2 2 0 0 1 2.131-3.199c2.888-2.641 7.258-2.779 10.301-.413l.935-.935a.63.63 0 0 0 .184-.5.5.5 0 0 0-.208-.382C13.502.77 7.505 1.613 4.166 5.781c-2.886 3.604-2.886 8.834 0 12.438C6.092 20.622 8.947 22 12 22s5.92-1.378 7.846-3.781c2.304-2.876 2.806-6.936 1.279-10.342a1 1 0 1 1 1.825-.818c1.831 4.084 1.224 8.955-1.544 12.41"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-radar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRadar;
